// preview is what the ESL actually displays; target is stored unchanged.
export type EslInk = "black" | "white" | "yellow" | "red" | "blue" | "green";

export interface IEslColor {
    ink: EslInk;
    target: string;
    preview: string;
}

export const eslColors: IEslColor[] = [
    { ink: "black",  target: "#000000", preview: "#030303" },
    { ink: "white",  target: "#FFFFFF", preview: "#DCDCDC" },
    { ink: "yellow", target: "#FFFF00", preview: "#F5D200" },
    { ink: "red",    target: "#FF0000", preview: "#A8181C" },
    { ink: "blue",   target: "#0000FF", preview: "#00528F" },
    { ink: "green",  target: "#00FF00", preview: "#127A1A" },
];
